<template>
    <app-data-table
        :fields="fields"
        :items="data.data"
        @sort="onSort"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >
        <template slot="structure" slot-scope="{ item }">
            {{  !!item.structure? item.structure.name: '' }}
        </template>

        <template slot="internal" slot-scope="{ item }">
            <div v-if="item.internal">SI</div> <div v-else>NO</div>
        </template>

        <template slot="actions" slot-scope="{ item }">
            <b-button size="sm" variant="primary" @click="seeCard(item)"><i class="fa fa-search-plus"></i></b-button>
            <b-button variant="primary" size="sm"  @click="startSavePhotos(item)"><i class="fa fa-camera"></i> </b-button>
            <b-button variant="primary" size="sm"  @click="startUpdate(item)"> <i class="fa fa-pencil" aria-hidden="true"></i> </b-button>
            <b-button variant="danger" size="sm"  @click="startRemove(item)"><i class="fa fa-trash-o" aria-hidden="true"></i></b-button>
        </template>
    </app-data-table>
</template>
<script>
    export default {
        data() {
            return {
                fields
            }
        },
        props: {
            data: {
                type: Object,
                required: true
            },
            seeCard: {
                type: Function,
                required: true
            },
            startSavePhotos: {
                type: Function,
                required: true
            },
            onChangePage: {
                type: Function,
                required: true
            },
            startUpdate: {
                type: Function,
                required: true
            },
            startRemove: {
                type: Function,
                required: true
            }
        },
        methods: {
            onSort(ctx) {
                this.$emit('sort', ctx);
            }
        }
    }

const fields = [
                    {
                        key: 'structure.name',
                        label: 'Estructura',
                        filter: true
                    },
                    {
                        key: 'vehicle_type.name',
                        label: 'Tipo de vehículo',
                        filter: true
                    },
                    {
                        key: 'plate',
                        label: 'Placa',
                        filter: true
                    },
                    {
                        key: 'brand',
                        label: 'Marca',
                        filter: true
                    },
                    {
                        key: 'internal',
                        label: 'Interno',
                        filter: true
                    },
                    {
                        key: 'person.name',
                        label: 'Propietario',
                        filter: false
                    },
                    {
                        key: 'notes',
                        label: 'Notas',
                        filter: false
                    },
                    {
                        key: 'actions',
                        label: 'Acciones'
                    }
                ]
</script>
